module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-row', {
    staticClass: "content-bottom-padded",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini",
      "placeholder": "请输入商品名称"
    },
    model: {
      value: (_vm.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.params, "keywords", $$v)
      },
      expression: "params.keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsNumberSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-upload"
    },
    on: {
      "click": function($event) {
        return _vm.handleBatchOnline(true)
      }
    }
  }, [_vm._v("批量上架")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-download"
    },
    on: {
      "click": function($event) {
        return _vm.handleBatchOnline(false)
      }
    }
  }, [_vm._v("批量下架")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleBatchDownload
    }
  }, [_vm._v("商品码下载")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item.name,
        "name": item.activeName
      }
    }, [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      ref: "multipleItemsTable",
      refInFor: true,
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.list,
        "height": _vm.wheight - 240
      },
      on: {
        "selection-change": _vm.handleItemsSelectionChange
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "selection",
        "width": "55"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "操作"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-button', {
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.handleSkuEdit(scope.row)
              }
            }
          }, [_vm._v("设置SKU")])]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "上下架操作"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-switch', {
            on: {
              "change": function($event) {
                return _vm.switchStatusChange(scope.$index, scope.row, true)
              }
            },
            model: {
              value: (scope.row.goods_can_sale),
              callback: function($$v) {
                _vm.$set(scope.row, "goods_can_sale", $$v)
              },
              expression: "scope.row.goods_can_sale"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "item_name",
        "label": "商品名称",
        "min-width": "300"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "price",
        "label": "商品价格",
        "min-width": "120"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n            " + _vm._s(scope.row.price) + "元\n          ")]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "approve_status",
        "label": "状态",
        "min-width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.approve_status === 'onsale') ? _c('div', {
            staticClass: "grid-content"
          }, [_vm._v(" 前台可销售 ")]) : (scope.row.approve_status === 'offline_sale') ? _c('div', {
            staticClass: "grid-content"
          }, [_vm._v(" 可线下销售 ")]) : _c('div', {
            staticClass: "grid-content"
          }, [_vm._v(" 不可销售 ")])]
        }
      }], null, true)
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "content-padded content-center"
    }, [_c('el-pagination', {
      attrs: {
        "background": "",
        "layout": "total, sizes, prev, pager, next",
        "current-page": _vm.params.page,
        "page-sizes": [10, 20, 50],
        "total": _vm.total_count,
        "page-size": _vm.params.pageSize
      },
      on: {
        "current-change": _vm.handleCurrentChange,
        "size-change": _vm.handleSizeChange,
        "update:currentPage": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        },
        "update:current-page": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        }
      }
    })], 1)], 1)
  }), 1), _vm._v(" "), _c('sideBar', {
    attrs: {
      "visible": _vm.show_sideBar,
      "title": "编辑店铺sku配置",
      "width": "60"
    },
    on: {
      "update:visible": function($event) {
        _vm.show_sideBar = $event
      }
    }
  }, [_vm._t("default", function() {
    return [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.itemSkuList,
        "height": _vm.wheight - 240
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "item_id",
        "width": "55"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "item_name",
        "label": "商品名称",
        "width": "200"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "item_spec_desc",
        "label": "规格",
        "width": "200"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "store",
        "label": "库存",
        "width": "120"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(_vm.editStore) ? _c('el-input', {
            model: {
              value: (scope.row.store),
              callback: function($$v) {
                _vm.$set(scope.row, "store", $$v)
              },
              expression: "scope.row.store"
            }
          }, [_c('i', {
            staticClass: "el-input__icon el-icon-edit",
            attrs: {
              "slot": "suffix"
            },
            slot: "suffix"
          })]) : _c('el-input', {
            attrs: {
              "disabled": ""
            },
            model: {
              value: (scope.row.store),
              callback: function($$v) {
                _vm.$set(scope.row, "store", $$v)
              },
              expression: "scope.row.store"
            }
          })]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "approve_status",
        "label": "状态",
        "width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.approve_status === 'onsale') ? _c('div', {
            staticClass: "grid-content"
          }, [_vm._v(" 前台可销售 ")]) : (scope.row.approve_status === 'offline_sale') ? _c('div', {
            staticClass: "grid-content"
          }, [_vm._v(" 可线下销售 ")]) : _c('div', {
            staticClass: "grid-content"
          }, [_vm._v(" 不可销售 ")])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "上下架操作",
        "width": "180"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-switch', {
            attrs: {
              "active-text": "已上架",
              "inactive-text": "已下架"
            },
            on: {
              "change": function($event) {
                return _vm.switchStatusChange(scope.$index, scope.row, false)
              }
            },
            model: {
              value: (scope.row.is_can_sale),
              callback: function($$v) {
                _vm.$set(scope.row, "is_can_sale", $$v)
              },
              expression: "scope.row.is_can_sale"
            }
          })]
        }
      }])
    })], 1)]
  })], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-32761b68", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32761b68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/shop/goods/companygoods.vue
// module id = 2598
// module chunks = 0